export const backgroundImages = [
    { 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/congreso.jpg" ,
      tagLine: "Edificio del Congreso - Ciudad Autonoma de Buenos Aires - Argentina",
      flag: "AR"
    } , { 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/aconcagua.jpg" ,
      tagLine: "Cerro Aconcagua - Parque Provincial Aconcagua - Mendoza - Argentina",
      flag: "AR"
    } ,{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/ballena.jpg" ,
      tagLine: "Avistaje de ballenas - Península Valdés - Chubut - Argentina",
      flag: "AR"
    } ,{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/caminito.jpg" ,
      tagLine: "Calle Caminito - La Boca - Ciudad Autonoma de Buenos Aires - Argentina",
      flag: "AR"
    } ,{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/cataratas.jpg" ,
      tagLine: "Las Cataratas del Iguazú - Parque Nacional Iguazú - Misiones - Argentina",
      flag: "AR"
    } ,{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/perito-moreno.jpg",
      tagLine: "Glaciar Perito Moreno - Lago Argentino - Santa Cruz - Argentina",
      flag: "AR"
    } ,{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/siete-colores.jpg", 
      tagLine: "Cerro de los Siete Colores - Purmamarca - Jujuy - Argentina ",
      flag: "AR"
    },{ 
      src: "https://alumni-images.s3.us-east-2.amazonaws.com/bg/villa-traful.jpg", 
      tagLine: "Lago Traful - Villa Traful - Neuquén - Argentina ",
      flag: "AR"
    }
    

  
  ]